import Swal from "sweetalert2";
import {
  PlanLimitResource,
  RESOURCE_LABELS,
  invalidatePlanUsage,
} from "./planUsage";

// Tratamento único do 422 PLAN_LIMIT_REACHED (AAC-65/66/67) nas telas de cadastro e envio (AAC-81).
// Qualquer outro erro devolve null/false e a tela segue com o tratamento que já tinha.
export const MY_PLAN_PATH = "/my-plan";

export type PlanLimitReason = "limit_reached" | "no_active_contract" | "no_limit";

export interface PlanLimitErrorBody {
  code: "PLAN_LIMIT_REACHED";
  resource: PlanLimitResource;
  limit: number;
  used: number;
  reason: PlanLimitReason;
  quantity?: number;
  error?: string;
}

export function getPlanLimitError(error: unknown): PlanLimitErrorBody | null {
  const response = (error as any)?.response;
  if (response?.status === 422 && response?.data?.code === "PLAN_LIMIT_REACHED") {
    return response.data as PlanLimitErrorBody;
  }
  return null;
}

export function planLimitMessage(body: PlanLimitErrorBody): string {
  const label = RESOURCE_LABELS[body.resource] ?? body.resource;
  if (body.reason === "no_active_contract") {
    return "Seu clube não tem contrato ativo. Fale com a AACCESON.";
  }
  if (body.reason === "no_limit") {
    return `Seu plano não inclui ${label}. Faça upgrade para o próximo plano.`;
  }
  const limite = `Seu plano permite ${body.limit} ${label}. Faça upgrade para o próximo plano.`;
  if (body.resource === "notifications" && typeof body.quantity === "number") {
    const restam = Math.max(body.limit - body.used, 0);
    return `Este envio teria ${body.quantity} destinatários; restam ${restam} no mês. ${limite}`;
  }
  return limite;
}

export async function showPlanLimitError(
  body: PlanLimitErrorBody,
  navigate: (to: string) => void,
): Promise<void> {
  invalidatePlanUsage();
  const semContrato = body.reason === "no_active_contract";
  const result = await Swal.fire({
    icon: "warning",
    title: "Limite do plano",
    text: planLimitMessage(body),
    showCancelButton: !semContrato,
    confirmButtonText: semContrato ? "Entendi" : "Ver planos",
    cancelButtonText: "Fechar",
  });
  if (result?.isConfirmed && !semContrato) navigate(MY_PLAN_PATH);
}

export function handlePlanLimitError(
  error: unknown,
  navigate: (to: string) => void,
): boolean {
  const body = getPlanLimitError(error);
  if (!body) return false;
  void showPlanLimitError(body, navigate);
  return true;
}
